module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/ups-2b6be7a21c4169c799a586c0e93a62f1.svg";